export default __webpack_public_path__ + "components/page-header/static/snow-badge--light-0c7f773d47fb3397efdae7d28c3023dc.svg";